import { useInsuranceForm } from '../hooks/use-insurance-form.hook';
import { InsuranceSection } from '../Settings/types';
import { CancelButton, FormModal, SubmitButton } from '../../../Form';
import { InsuranceDetailsForm } from './insurance-details-form.form';
import { InsuranceCardForm } from './insurance-card-form.form';
import { Formik } from 'formik';
import { ModalActions } from '../../../Modal';
import { PrimarySubscriberFormBlock } from './primary-subscriber-form-block.component';
import { Box, Divider } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

export type EditInsuranceFormModalProps = {
  isMobile?: boolean;
  insuranceSection: InsuranceSection;
  patientId: string;
  open: boolean;
  onClose: () => void;
};

export const EditInsuranceFormModal: React.VFC<EditInsuranceFormModalProps> = ({
  isMobile = false,
  insuranceSection,
  patientId,
  open,
  onClose }) => {
  const { insuranceFormik } = useInsuranceForm(patientId, insuranceSection, false, onClose);
  const { classes } = useStyles();

  return (
    <Formik {...insuranceFormik()}>
      <FormModal
        open={open}
        title="Edit Insurance"
        onClose={onClose}
        maxWidth="md"
        fullWidth
      >
        <Box className={classes.form}>
          <Box pb={3}>
            <InsuranceDetailsForm insuranceSection={insuranceSection} patientId={patientId} />
          </Box>
          <Box pb={3}>
            <InsuranceCardForm isMobile={isMobile} gap="24px" mt={3} pr={!isMobile ? 1 : 0} />
          </Box>
          <PrimarySubscriberFormBlock patientId={patientId} isModal/>
        </Box>
        <Divider />
        <ModalActions>
          <CancelButton onClick={onClose}>
            CANCEL
          </CancelButton>
          <SubmitButton color="secondary">
            SAVE
          </SubmitButton>
        </ModalActions>
      </FormModal>
    </Formik>
  );
};

const useStyles = makeStyles()((theme) => ({
  form: {
    padding: theme.spacing(3),
  }
}));
